import some from 'lodash/some';

import { SCROLLABLE_PATHS } from '../constants/main';

export const getIndependentScrolling = ({
    location: { pathname } = {},
} = {}) => {
    let independentScrolling = false;

    if (pathname) {
        independentScrolling = some(
            SCROLLABLE_PATHS,
            (path) => pathname.indexOf(path) > -1,
        );
    }

    return independentScrolling;
};
